// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/payables/recurring-expenses',
        component: () =>
            import('@/pages/[organisation]/payables/recurring-expenses.vue'),
        name: 'accounts-payable.recurring-expenses.search-recurring-expenses',
        meta: {
            loginRequired: true,
            permission: 'access.payables.recurring-expense.view-recurring-expenses',
        },

        children: [
            {
                path: 'create-recurring-expense',
                component: () =>
                    import('@/pages/[organisation]/payables/recurring-expenses/create-recurring-expense.vue'),
                name: 'accounts-payable.recurring-expenses.create-recurring-expense',
                meta: {
                    loginRequired: true,
                    permission: 'access.payables.recurring-expense.create-recurring-expense',
                },
            },
            {
                path: ':id/update-recurring-expense',
                component: () =>
                    import(/* webpackChunkName: "accounts-payable.recurring-expenses" */ '@/pages/[organisation]/payables/recurring-expenses/recurring-expense/[id]/edit.vue'),
                name: 'accounts-payable.recurring-expenses.update-recurring-expense',
                meta: {
                    loginRequired: true,
                    permission: 'access.payables.recurring-expense.update-recurring-expense',
                },
            },
            {
                path: ':id',
                component: () =>
                    import(/* webpackChunkName: "accounts-payable.recurring-expenses" */ '@/pages/[organisation]/payables/recurring-expenses/recurring-expense/[id].vue'),
                name: 'accounts-payable.recurring-expenses.view-recurring-expense',
                meta: {
                    loginRequired: true,
                    permission: 'access.payables.recurring-expense.view-recurring-expenses',
                },
            },
        ],
    },
];
